import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/styles";
import { Modal, Typography, Paper, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import GPSLocation from "./Icon/GPSLocation.png";
import ButtonBlue from "../../../../../shared/buttonBlue";
import {
  GoogleAPIkey,
  locationSite1,
} from "../../../../../../../utils/googleMapAssets";
import {
  GoogleMap,
  Marker,
  useLoadScript,
  InfoWindow,
} from "@react-google-maps/api";
import SiteService from "../../../../../../../services/site.service";
import { getLocationAndVehicleUsage } from "../../../../../../../actions/locationVehicle";
import MarkerDriver from "./MarkerDriver";

const placesLibrary = ["places"];

const useStyles = makeStyles((theme) => ({
  Modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  Paper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "90%",
    height: "85%",
    padding: "20px",
  },
  partOfTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
    gap: "10px",
  },
  partOfTitleLeft: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    width: "100%",
  },
  IconCar: {
    fontSize: "40px",
    marginRight: "10px",
    color: theme.palette.primary.main,
  },
  Title: {
    fontSize: "30px",
    color: theme.palette.primary.main,
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  Detail: {
    fontSize: "16px",
    color: theme.palette.primary.main,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
}));
const AlertMessage = styled("div")({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
  fontSize: "16px",
  color: "red",
  textAlign: "center",
});

const GoogleApi = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [isLocationDriver, setLocationDriver] = useState([]);
  const [isLocationFrom, setLocationFrom] = useState([{ Lat: 0, Lng: 0 }]);
  const [isLocationTo, setLocationTo] = useState([{ Lat: 0, Lng: 0 }]);
  const [deliveredPackageLocation, setDeliveredPackageLocation] =
    useState(null);
  const [refresh, setRefresh] = useState(false);
  const handleClick = () => {
    setRefresh((prev) => !prev);
  };
  const {
    isError: isErrorLocationVehicle,
    isFetching: isFetchingLocationVehicle,
    result: locationVehicle,
  } = useSelector((state) => state.locationVehicle);
  const { isLoaded } = useLoadScript({
    id: "google-map-script",
    googleMapsApiKey: GoogleAPIkey,
    libraries: placesLibrary,
    language: "th",
    region: "TH",
  });
  const customCenter = {
    url: GPSLocation,
    scaledSize: new window.google.maps.Size(25, 50), // Size of the icon
    origin: new window.google.maps.Point(0, 0), // Origin point
    anchor: new window.google.maps.Point(25, 50), // Anchor point
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch Location Driver Delivery Sample Shuttle
        if (props.typeOfBooking === "DeliverySampleShuttle") {
          dispatch(getLocationAndVehicleUsage(props.inforInCar.idDriver));
        }
        // Fetch Location Driver (Compatible with any type of booking)
        else {
          const result = await SiteService.getLocationDriverById(
            props.inforInCar.idDriver
          );
          if (result.data.length > 0) {
            setLocationDriver([
              {
                Lat: result.data[0].lat,
                Lng: result.data[0].lng,
                lastUpdate: result.data[0].lastUpdate,
              },
            ]);
          } else {
            console.log("Driver Location Not Found");
          }
        }
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchData();

    // Assign from - to latitude & longitude (Compatible with both Delivery Sample Shuttle and Between Site Car services)
    if (
      props.inforInCar != null &&
      props.inforInCar.fromPlace &&
      props.inforInCar.toPlace
    ) {
      if (props.inforInCar.fromLat && props.inforInCar.fromLong) {
        setLocationFrom([
          { Lat: props.inforInCar.fromLat, Lng: props.inforInCar.fromLong },
        ]);
      } else {
        setLocationFrom([{ Lat: 0, Lng: 0 }]);
      }
      if (props.inforInCar.toLat && props.inforInCar.toLong) {
        setLocationTo([
          { Lat: props.inforInCar.toLat, Lng: props.inforInCar.toLong },
        ]);
      } else {
        setLocationTo([{ Lat: 0, Lng: 0 }]);
      }
    }

    // Delivery Sample Shuttle
    if (props.typeOfBooking === "DeliverySampleShuttle") {
      if (
        (props.inforInCar.status === "ส่งสินค้าเรียบร้อย" ||
          props.inforInCar.status === "ได้รับสินค้าเรียบร้อย") &&
        props.inforInCar.deliveredLat &&
        props.inforInCar.deliveredLng
      ) {
        setDeliveredPackageLocation({
          Lat: props.inforInCar.deliveredLat,
          Long: props.inforInCar.deliveredLng,
        });
      }
    }
  }, [props.inforInCar, refresh]);

  useEffect(() => {
    if (
      locationVehicle &&
      locationVehicle?.length > 0 &&
      locationVehicle[0].endTime === null
    ) {
      console.log("yes");
      
      setLocationDriver([
        {
          Lat: locationVehicle[0].lat,
          Lng: locationVehicle[0].lng,
          lastUpdate: locationVehicle[0].lastUpdate,
        },
      ]);
    }
  }, [locationVehicle]);

  // For Google Map
  const containerStyle = {
    width: "100%",
    height: "100%",
  };

  // console.log(locationVehicle);
  console.log(isLocationDriver);
  console.log(isLocationDriver.length);
  
  

  const isDelivered =
    props.typeOfBooking === "DeliverySampleShuttleCar" &&
    props.inforInCar?.status === "ส่งสินค้าเรียบร้อย" &&
    deliveredPackageLocation;

  const defaultProps = {
    center: isDelivered
      ? {
          lat: parseFloat(deliveredPackageLocation.Lat),
          lng: parseFloat(deliveredPackageLocation.Long),
        }
      : null,
    zoom: isDelivered ? 15 : null,
  };

  return (
    <>
      {isLoaded && (
        <Modal
          className={`${classes.Modal}`}
          open={props.open}
          onClose={props.onCloseHandle}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <Paper className={`${classes.Paper}`}>
            <div className={`${classes.partOfTitle}`}>
              <div className={`${classes.partOfTitleLeft}`}>
                <DriveEtaIcon className={`${classes.IconCar}`} />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  {/* If not status รอรับสินค้า and ส่งสินค้าเรียบร้อย -> Show Refresh Button */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      // gap: "10px",
                      alignItems: "start",
                      // flexWrap: "wrap",
                      marginRight: "10px",
                    }}
                  >
                    <Typography className={`${classes.Title}`}>
                      แสดงแผนที่
                    </Typography>
                    {(!isFetchingLocationVehicle &&
                      !isErrorLocationVehicle &&
                      (props.typeOfBooking === "DeliverySampleShuttle" &&
                      props.inforInCar?.idDriver &&
                      isLocationDriver?.length > 0 &&
                      locationVehicle[0].endTime === null &&
                      props.inforInCar.status !== "ส่งสินค้าเรียบร้อย") ||
                      (props.typeOfBooking === "BetweenSiteCar" &&
                        props.inforInCar.isFinish === 0 &&
                        isLocationDriver?.length > 0)) && (
                      <Typography className={`${classes.Detail}`}>
                        {new Date(
                          isLocationDriver[0].lastUpdate
                        ).toLocaleString("th-TH", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </Typography>
                    )}
                  </div>
                  <ButtonBlue
                    variant="contained"
                    style={{ height: "35px" }}
                    onClick={handleClick}
                  >
                    Refresh
                  </ButtonBlue>
                </div>
              </div>
              <IconButton
                className={`${classes.IconButtonClose}`}
                onClick={props.onCloseHandle}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <div style={{ height: "90%", width: "100%" }}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={defaultProps.center}
                zoom={defaultProps.zoom}
              >
                {isLocationFrom.length > 0 && (
                  <Marker
                    position={{
                      lat: parseFloat(isLocationFrom[0].Lat),
                      lng: parseFloat(isLocationFrom[0].Lng),
                    }}
                    icon={{
                      url:
                        "data:image/svg+xml;charset=UTF-8," +
                        encodeURIComponent(`
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#005f40" width="56px" height="56px">
                            <path d="M12 2C8.69 2 6 4.69 6 8c0 3.53 3.87 7.61 5.47 9.19.3.3.77.3 1.06 0C14.13 15.61 18 11.53 18 8c0-3.31-2.69-6-6-6zm0 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
                          </svg>
                    `),
                    }}
                  />
                )}
                {isLocationTo.length > 0 && (
                  <Marker
                    position={{
                      lat: parseFloat(isLocationTo[0].Lat),
                      lng: parseFloat(isLocationTo[0].Lng),
                    }}
                    icon={{
                      url:
                        "data:image/svg+xml;charset=UTF-8," +
                        encodeURIComponent(`
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#d9534f" width="56px" height="56px">
                          <path d="M12 2C8.69 2 6 4.69 6 8c0 3.53 3.87 7.61 5.47 9.19.3.3.77.3 1.06 0C14.13 15.61 18 11.53 18 8c0-3.31-2.69-6-6-6zm0 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
                        </svg>
                  `),
                    }}
                  />
                )}
                {props.typeOfBooking === "DeliverySampleShuttle" &&
                  (props.inforInCar.status === "ส่งสินค้าเรียบร้อย" ||
                    props.inforInCar.status === "ได้รับสินค้าเรียบร้อย") &&
                  deliveredPackageLocation && (
                    <Marker
                      position={{
                        lat: parseFloat(deliveredPackageLocation.Lat),
                        lng: parseFloat(deliveredPackageLocation.Long),
                      }}
                      icon={{
                        url:
                          "data:image/svg+xml;charset=UTF-8," +
                          encodeURIComponent(`
                       <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#007bff" d="M32 32l448 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96L0 64C0 46.3 14.3 32 32 32zm0 128l448 0 0 256c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-256zm128 80c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16z"/></svg>
                      `),
                      }}
                      onClick={() => {
                        window.open(
                          `https://www.google.com/maps?q=${deliveredPackageLocation.Lat},${deliveredPackageLocation.Long}`,
                          "_blank"
                        );
                      }}
                    >
                      <InfoWindow
                        position={{
                          lat: parseFloat(deliveredPackageLocation.Lat),
                          lng: parseFloat(deliveredPackageLocation.Long),
                        }}
                        options={{
                          pixelOffset: new window.google.maps.Size(0, -24),
                        }}
                      >
                        <div>
                          <h3>ตำแหน่งที่ส่งพัสดุสำเร็จ</h3>
                          <p>Latitude: {deliveredPackageLocation.Lat}</p>
                          <p>Longitude: {deliveredPackageLocation.Long}</p>
                        </div>
                      </InfoWindow>
                    </Marker>
                  )}
                <MarkerDriver
                  typeOfBooking={props.typeOfBooking}
                  inforInCar={props.inforInCar}
                  refresh={refresh}
                  siteFrom={isLocationFrom[0]}
                  siteTo={isLocationTo[0]}
                />
                {props.inforInCar.idDriver === null &&
                  (props.typeOfBooking === "BetweenSiteCar" ||
                    (props.typeOfBooking === "DeliverySampleShuttle" &&
                      props.inforInCar.status === "รอรับสินค้า")) && (
                    <AlertMessage>กำลังจัดหาคนขับ...</AlertMessage>
                  )}
                {props.inforInCar.status === "รับสินค้าเรียบร้อย" &&
                  (locationVehicle?.length <= 0 ||
                    (locationVehicle?.length > 0 &&
                      locationVehicle[0].endTime !== null)) && (
                    <AlertMessage>ไม่มีการเชื่อมต่อ GPS จากคนขับ</AlertMessage>
                  )}

                {props.inforInCar.status === "รับสินค้าเรียบร้อย" &&
                  (isErrorLocationVehicle && 
                    <AlertMessage>เกิดข้อผิดพลาดในการดึงข้อมูล<br />ตำแหน่งของคนขับรถ</AlertMessage>
                  )}

                {(props.inforInCar.status === "ส่งสินค้าเรียบร้อย" ||
                  props.inforInCar.status === "ได้รับสินค้าเรียบร้อย") && (
                  <AlertMessage style={{ color: "#2196F3" }}>
                    ส่งพัสดุเรียบร้อย <br />{" "}
                    {!deliveredPackageLocation &&
                      "ไม่พบตำแหน่งส่งพัสดุสำเร็จในระบบ"}
                  </AlertMessage>
                )}
              </GoogleMap>
            </div>
          </Paper>
        </Modal>
      )}
    </>
  );
};

export default GoogleApi;
